export default {
    auth: {
        group: {
            auditor: 1,
            controller: 2,
            admin: 3
        }
    },
    status: {
        altAsset: {
            created: 1,
            matched: 2,
            rejected: 3
        },
        audit: {
            awaitingDownload: 1,
            pendingCount: 2,
            partiallyCompleteCount: 3,
            pendingReview: 4,
            inReview: 5,
            closed: 6
        },
        auditAssignment: {
            pendingDownload: 1,
            pendingSubmission: 2,
            submitted: 3,
            recalled: 4
        },
        reissued: {
            reissued: 1,
            resolved: 2,
            unresolved: 3
        },
        exclusionReason: {
            assetIsSold: 2,
            assetDeliveredToCustomerAndNotPaid: 11
        },
        assetStatus: {
            pending: 1,
            seen: 2,
            excluded: 3
        },
        settings: {
            signatureRequired: 3
        }
    },
    organisationIds: {
        stellantisFinanceFrance: 40,
        bureauVeritas: 42,
        dilwariGroup: 45,
        volkswagen: 3
    },
    types: {
        altAssetResolution: {
            rejectAsset: 10
        },
        assetAttribute: {
            condition: 4
        }
    }
};
